mod.modules.define("HistoricalPdfs", "BaseModule", function(fn) {
	"use strict";

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.reportType = $("select.select-reportType-13", this.el);
		this.reportMonth = $("select.select-selectMonth-13", this.el);
		this.reportYear = $("select.select-selectYear-13", this.el);

		if (this.el.find("div.pager-wrap").length) {
			this.addPlugin("Plugin-Paging");
		}
	};

	fn.prototype.loadReports = function(e, $el) {
		var self = this;

		var months = this.reportMonth.val().split("|");

		var loadData = {};
		loadData.ReportType = this.reportType.val();

		if (months.length > 0) {
			loadData.StartMonth = months[0];
		}

		if (months.length > 1) {
			loadData.EndMonth = months[1];
		}

		loadData.SelectedYear = this.reportYear.val();

		this.reload(loadData);
	};

	fn.prototype.events = {
		"button[data-action=findReport]": {
			"click": function(e, $el) {
				this.loadReports(e, $el);
			}
		},
		".pager-wrap [data-pageindex]:not([disabled=disabled])": {
			"click": function(e, $el) {
				this.pageIndex = $el.attr("data-pageindex");
				this.loadReports(e, $el);
			}
		}
	};

});